import { Pipe, PipeTransform } from '@angular/core';
import { ConvertedIntentTopicInterface } from '../models/converted-intent-topic.interface';

/**
 * Hides the topics under collapsed categories (category rows are always kept).
 * Pure pipe — pass a new Set reference on each toggle so it re-runs.
 */
@Pipe({
    name: 'collapsedCategoriesFilter',
    standalone: false
})
export class CollapsedCategoriesFilterPipe implements PipeTransform {
    transform(topics: ConvertedIntentTopicInterface[], collapsed: Set<string>): ConvertedIntentTopicInterface[] {
        if (!collapsed?.size) {
            return topics;
        }

        let currentCollapsed: boolean = false;
        return (topics || []).filter((topic: ConvertedIntentTopicInterface) => {
            if (topic.category) {
                currentCollapsed = collapsed.has(topic.category);
                return true;
            }
            return !currentCollapsed;
        });
    }
}
